module.exports = __webpack_public_path__ + "static/media/weisen.687b534a.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/weisen.JPG
// module id = 695
// module chunks = 0